export default "__VITE_ASSET__cD9xJxDX__"